import React from "react";
import "./style.scss";

export default function PaginationComponent({ current, total }) {
  return (
    <div className="pagination-component">
      <span>{current}</span>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 29L29.2843 0.715726" stroke="white" />
      </svg>
      <span>{total}</span>
    </div>
  );
}
